import AppBar from '@material-ui/core/AppBar';
import config from 'shared/config';
import Customer from 'models/Customer';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import ErrorBoundary from 'shared/components/ErrorBoundary';
import PropTypes from 'prop-types';
import React from 'react';
import ToolBar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom';
import { List, ListItem, ListItemText } from '@material-ui/core';
import { Scrollbars } from 'react-custom-scrollbars';
import { withStyles } from '@material-ui/core/styles';
import MainDrawerLeftIcons from './MainDrawerLeftIcons';
import TreeContainer from '../containers/TreeContainer';

// injected into the component using 'withStyles'
const styles = theme => ({
	root: {
		width: '100%',
		flex: '1 0 auto',
		height: '100vh',
		display: 'flex',
		position: 'fixed',
		overflowY: 'auto',
		flexDirection: 'column',

		[theme.breakpoints.up('xs')]: {
			width: '100%',
		},
		[theme.breakpoints.up('sm')]: {
			width: '50%',
		},
		[theme.breakpoints.up('md')]: {
			width: '33%',
		},
		[theme.breakpoints.up('lg')]: {
			width: '25%',
		},
	},
	appbar: {
		boxShadow: 'none',

		[theme.breakpoints.down('xs')]: {
			paddingLeft: '8px',
		},
	},
	leftDrawerLinks: {
		textTransform: 'uppercase',
	},
	listItem: {
		padding: '10px 10px 10px 12px',
		height: '36px',
		textTransform: 'uppercase',
	},
});

const NavMainDrawer = props => {
	const {
		classes,
		closeMainDrawer,
		customer,
		isMainDrawerOpen,
		logout,
		openLogin,
		openRegistration,
		openStoreModal,
		toggleMainDrawer,
	} = props;

	return (
		<Drawer
			open={isMainDrawerOpen}
			onClose={toggleMainDrawer}
			PaperProps={{ className: classes.root }}
			keepMounted
		>
			<AppBar className={classes.appbar} position="static">
				<ToolBar style={{ margin: '8px 8px -8px -16px' }}>
					<MainDrawerLeftIcons closeDrawer={closeMainDrawer} customer={customer} logout={logout} />
				</ToolBar>
			</AppBar>
			<ErrorBoundary>
				<Scrollbars>
					<List>
						{customer.isGuest && config.GENERAL.ShowLoginRegistration ? (
							<div>
								<ListItem button className={classes.listItem} key="login" onClick={openLogin}>
									<ListItemText primary="LOG IN" />
								</ListItem>
								<ListItem
									button
									className={classes.listItem}
									key="register"
									onClick={openRegistration}
								>
									<ListItemText primary="REGISTER" />
								</ListItem>
							</div>
						) : null}
						<ListItem button className={classes.listItem} key="store" onClick={openStoreModal}>
							<ListItemText primary="CHANGE STORE" />
						</ListItem>
						<ListItem
							button
							className={classes.listItem}
							key="shop"
							component={Link}
							to="/category"
							onClick={closeMainDrawer}
						>
							<ListItemText primary="SHOP" />
						</ListItem>
						{// User defined topics. Created through the eSTORIS admin panel.
						props.brandTopics
							? props.brandTopics.map((topic, index) => (
									<ListItem
										button
										className={classes.listItem}
										key={`${topic.title}${index.toString()}`}
										component={Link}
										to={`/topic/${index}`}
										onClick={closeMainDrawer}
									>
										<ListItemText primary={topic.title} />
									</ListItem>
								))
							: null}
					</List>
					<Divider style={{ minHeight: '1px' }} />
					<div>
						<TreeContainer closeDrawer={closeMainDrawer} />
					</div>
				</Scrollbars>
			</ErrorBoundary>
		</Drawer>
	);
};

NavMainDrawer.propTypes = {
	classes: PropTypes.shape({
		root: PropTypes.string,
		appbar: PropTypes.string,
		leftDrawerLinks: PropTypes.string,
		listItem: PropTypes.string,
	}).isRequired,
	closeMainDrawer: PropTypes.func.isRequired,
	customer: PropTypes.instanceOf(Customer).isRequired,
	isMainDrawerOpen: PropTypes.bool,
	logout: PropTypes.func.isRequired,
	openLogin: PropTypes.func.isRequired,
	openRegistration: PropTypes.func.isRequired,
	openStoreModal: PropTypes.func.isRequired,
	toggleMainDrawer: PropTypes.func.isRequired,
	brandTopics: PropTypes.arrayOf(PropTypes.object),
};

NavMainDrawer.defaultProps = {
	isMainDrawerOpen: false,
	brandTopics: undefined,
};

// for testing purposes
export { NavMainDrawer as NavMainDrawerClass };

export default withStyles(styles, { name: 'NavMainDrawer' })(NavMainDrawer);
